import { USER_ROLES, VALID_OPERATOR_ROLES, VALID_USER_ROLES } from "./user.constants";

export enum MENU_GROUPS {
  "Header" = "Header",
  "Footer" = "Footer",
}

export enum MENU_ITEM_TYPES {
  "Page" = "Page",
  "Module" = "Module",
}

export enum MENU_MODULE_NAMES {
  "account_settings" = "account_settings",
  "admin_home" = "admin_home",
  "subscriptions" = "subscriptions",
  "member_login" = "member_login",
  "member_logout" = "member_logout",
}

export enum MENU_DISPLAY_TYPES {
  "Always" = "Always",
  "Authenticated" = "Authenticated",
  "Anonymous" = "Anonymous",
}

export interface MenuItem {
  id?: string;
  group?: string;
  page?: any;
  module?: string | MENU_MODULE_NAMES;
  order?: number;
  label: string;
  path: string;
  type: MENU_ITEM_TYPES;
  roles: USER_ROLES[];
  display?: MENU_DISPLAY_TYPES;
  icon: string;
  items?: MenuItem[];
}

export interface MenuGroup {
  group: MENU_GROUPS;
  items: MenuItem[];
}

export const MENU_MODULES: MenuItem[] = [
  {
    module: MENU_MODULE_NAMES.account_settings,
    label: "Account Settings",
    path: "/member/account/settings",
    type: MENU_ITEM_TYPES.Module,
    icon: "pi-user",
    display: MENU_DISPLAY_TYPES.Authenticated,
    roles: VALID_USER_ROLES,
  },
  {
    module: MENU_MODULE_NAMES.admin_home,
    label: "Admin Home",
    path: "/admin",
    type: MENU_ITEM_TYPES.Module,
    icon: "pi-cog",
    display: MENU_DISPLAY_TYPES.Authenticated,
    roles: VALID_OPERATOR_ROLES,
  },
  {
    module: MENU_MODULE_NAMES.subscriptions,
    label: "Subscriptions",
    path: "/subscriptions",
    type: MENU_ITEM_TYPES.Module,
    icon: "pi-shopping-cart",
    display: MENU_DISPLAY_TYPES.Always,
    roles: [],
  },
  {
    module: MENU_MODULE_NAMES.member_login,
    label: "Login",
    path: "/member/login",
    type: MENU_ITEM_TYPES.Module,
    icon: "pi-lock",
    display: MENU_DISPLAY_TYPES.Anonymous,
    roles: [],
  },
  {
    module: MENU_MODULE_NAMES.member_logout,
    label: "Logout",
    path: "/member/logout",
    type: MENU_ITEM_TYPES.Module,
    icon: "pi-unlock",
    display: MENU_DISPLAY_TYPES.Authenticated,
    roles: [],
  },
];
